import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"home\"><path fill-rule=\"evenodd\" d=\"M10 20.5v-6h4v6h5v-8h3l-10-9-10 9h3v8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol